import i18next from '@bonanza-social/i18n';
import en from './en.json';
import fr from './fr.json';

i18next.addResources('en', 'games', en);
i18next.addResources('fr', 'games', fr);

declare global {
  interface RegisteredLocales {
    games: typeof en;
  }
}
